import styled from "styled-components";

export const AddBranchStyles = styled.section`
  min-height: calc(100vh - 42px);

  form {
    margin-top: 24px;
  }
`;
